import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faBirthdayCake,
  faVenusMars,
  faGlobe,
  faGraduationCap,
  faWineGlass,
  faSmoking,
  faEdit
} from "@fortawesome/free-solid-svg-icons";

import React, {useContext, useEffect, useState} from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";

const MedicalData = ({ patient }) => {
  const { t } = useTranslation();
  const context = useContext(InitContext);
  const [smokingDialogOpened, setSmokingDialogOpened] = useState(false);
  const [drinkingDialogOpened, setDrinkingDialogOpened] = useState(false);
  const [smoking, setSmoking] = useState(patient?.smoking_habit ?? "");
  const [drinking, setDrinking] = useState(patient?.drinking_habit ?? "");
  const [drinkingFrequency, setDrinkingFrequency] = useState(patient?.drinking_frequency ?? "");
  const { updateDbUser } = useMmcService();

  useEffect(() => {
    setSmoking(patient?.smoking_habit ?? "");
  }, [patient?.smoking_habit]);

  useEffect(() => {
    setDrinking(patient?.drinking_habit ?? "");
  }, [patient?.drinking_habit]);

  useEffect(() => {
    setDrinkingFrequency(patient?.drinking_frequency ?? "");
  }, [patient?.drinking_frequency]);

  const saveSmoking = () => {
    setSmokingDialogOpened(false);
    const patientData = { ...patient, smoking_habit: smoking };
    updateDbUser(context?.token, patientData, patient?.id).then();
  }

  const cancelEditingSmoking = () => {
    setSmoking(patient?.smoking_habit);
    setSmokingDialogOpened(false);
  }

  const cancelEditingDrinking = () => {
    setDrinking(patient?.drinking_habit);
    setDrinkingDialogOpened(false);
  }

  const saveDrinking = () => {
    setDrinkingDialogOpened(false);
    const patientData = { ...patient, drinking_habit: drinking, drinking_frequency: drinkingFrequency };
    updateDbUser(context?.token, patientData, patient?.id).then();
  }

  const smokingOptions = ["occasionally_regularly", "never", "previous"];
  const drinkingOptions = ["occasionally", "never", "previous"];

  const drinkingFrequencyOptions = [
    "daily_or_almost_daily",
    "three_or_four_times_a_week",
    "once_or_twice_a_week",
    "one_or_three_times_a_month",
  ];

  return (
    <div className="w3-container w3-left-align">
      {smokingDialogOpened && (
        <div className="feedback-modal">
          <div className="print-modal-content">
            <header className="feedback-modal-header">
              <h2>{t("select")}</h2>
            </header>
            <RadioGroup
              aria-labelledby="smoking-group"
              name="smoking-group"
              value={smoking}
              onChange={(e => setSmoking(e.target.value))}
            >
              <div className="w3-container">
                {smokingOptions?.map((radioValue, i) => {
                  return (
                    <div className="w3-container" key={`smoking${i}`}>
                      <FormControlLabel
                        key={`smokingValue${i}`}
                        value={radioValue}
                        control={<Radio />}
                        label={t(radioValue)}
                      />
                    </div>
                  );
                })}
              </div>
            </RadioGroup>
            <div className="feedback-modal-buttons">
              <button onClick={saveSmoking} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("save")}
              </button>
              <button onClick={cancelEditingSmoking} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      {drinkingDialogOpened && (
        <div className="feedback-modal">
          <div className="drinking-modal-content">
            <div className="w3-row">
              <div className="w3-col s5 w3-mobile">
                <header className="feedback-modal-header">
                  <h2>{t("your_alcohol_consumption")}</h2>
                </header>
                <RadioGroup
                  aria-labelledby="drinking-group"
                  name="drinking-group"
                  value={drinking}
                  onChange={(e => setDrinking(e.target.value))}
                >
                  <div className="w3-container">
                    {drinkingOptions?.map((radioValue, i) => {
                      return (
                        <div className="w3-container" key={`drinking${i}`}>
                          <FormControlLabel
                            key={`drinkingValue${i}`}
                            value={radioValue}
                            control={<Radio />}
                            label={ t(radioValue) }
                          />
                        </div>
                      );
                    })}
                  </div>
                </RadioGroup>
              </div>
              { (drinking === "occasionally" || drinking === "previous") &&
                <div className="w3-col s7 w3-mobile w3-border">
                  <header className="feedback-modal-header">
                    <h2>{t("frequency")}</h2>
                  </header>
                  <RadioGroup
                    aria-labelledby="drinking-frequency-group"
                    name="drinking-frequency-group"
                    value={drinkingFrequency}
                    defaultValue={drinkingFrequency}
                    onChange={(e => setDrinkingFrequency(e.target.value))}
                  >
                    <div className="w3-container">
                      {drinkingFrequencyOptions?.map((radioValue, i) => {
                        return (
                          <div className="w3-container" key={`drinkingFrequency${i}`}>
                            <FormControlLabel
                              key={`drinkingFrequencyValue${i}`}
                              value={radioValue}
                              control={<Radio />}
                              label={
                                <div className="w3-container">
                                  <label className="w3-margin-left">{ t(radioValue) }</label>
                                </div>
                              }
                            />
                          </div>
                        );
                      })}
                    </div>
                  </RadioGroup>
                </div>
              }
            </div>
            <div className="feedback-modal-buttons">
              <button onClick={saveDrinking} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("save")}
              </button>
              <button onClick={cancelEditingDrinking} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="w3-row w3-padding-small w3-border">
        <div className="w3-col s6">
          <FontAwesomeIcon icon={faBirthdayCake} className=" icon-block" />{" "}
          <label>{t("date_of_birth")}: {patient?.year_of_birth}</label>
        </div>
        <div className="w3-col s6">
          <FontAwesomeIcon icon={faVenusMars} className=" icon-block" />{" "}
          <label>{t("genotypic_sex")}: {t(patient?.gender)}</label>
        </div>
      </div>
      <div className="w3-row w3-padding-small w3-border">
        <div className="w3-col s6">
          <FontAwesomeIcon icon={faGlobe} className=" icon-block" />
          <label>{t("ethnicity")}: {patient?.ethnicity ? t(patient?.ethnicity?.toLowerCase()) : "-"}</label>
        </div>
        <div className="w3-col s6">
          <FontAwesomeIcon icon={faGraduationCap} className=" icon-block" />
          <label>{t("highest_level_of_education")}: {t(patient?.education)}</label>
        </div>
      </div>
      <div className="w3-row w3-padding-small w3-border">
        <div className="w3-col s6">
          <FontAwesomeIcon icon={faSmoking} className=" icon-block" />
          <label>
            {t("smoking_habits")}: {smoking ? t(smoking).toLowerCase() : "-"}
            <FontAwesomeIcon icon={faEdit} className="w3-margin-left icon-block" onClick={ () => setSmokingDialogOpened(true) }/>
          </label>
        </div>
        <div className="w3-col s6">
          <FontAwesomeIcon icon={faWineGlass} className=" icon-block"/>
          <label>{t("alcohol_consuming")}: {" "}{drinking ? t(drinking).toLowerCase() : "-"}
            {drinkingFrequency && drinking !== "never" && ` (${t(drinkingFrequency).toLowerCase()})`}
            <FontAwesomeIcon icon={faEdit} className="w3-margin-left icon-block"  onClick={ () => setDrinkingDialogOpened(true) } />
          </label>
        </div>
      </div>
    </div>
  );
};

export default MedicalData;
